import React from 'react';
import { jst, records, text } from './waf-model';
import type { WafComponent } from './waf-model';

export const logActions = ['COUNT', 'BLOCK', 'ALLOW'] as const;

export function WafLogTable({ logs, error, search = '', action = '', loading = false }: {
  logs?: WafComponent; error?: string; search?: string; action?: string; loading?: boolean;
}) {
  const source = records(logs?.records);
  const supported = source.filter(row => logActions.some(value => value === row.action));
  const rows = supported.filter(row => (!action || row.action === action) && JSON.stringify(row).toLowerCase().includes(search.toLowerCase()));
  const status = String(logs?.status || 'not_collected').toLowerCase();
  const coverage = String(logs?.coverageStatus || '').toLowerCase();
  const partial = !!logs?.truncated || ['partial', 'warning'].includes(status) || coverage === 'partial';
  const failed = ['error', 'access_denied'].includes(status);
  const failure = error || (failed ? logs?.message || (status === 'access_denied' ? 'ログを取得する権限がありません。' : 'ログを取得できませんでした。') : '');
  const empty = coverage === 'outside_retention' || status === 'outside_retention' ? '指定期間のログは保持期間外です。'
    : supported.length ? '条件に一致するログはありません。'
    : source.length ? 'COUNT・BLOCK・ALLOWのログはありません。'
    : partial ? '取得できたログはありません。'
    : ['active', 'collected', 'complete'].includes(status) ? 'ログはありません。'
    : ['not_configured', 'disabled', 'inactive'].includes(status) ? 'ログは未設定です。'
    : 'ログは未取得です。';
  const display = (value: unknown) => value === undefined || value === null || value === '' ? '—' : text(value);
  return <div className="table-container waf-log-table"><table aria-label="WAFログ">
    <thead><tr><th>日時 JST</th><th>IP / 国</th><th>URI / メソッド</th><th>動作</th><th>終了ルール</th></tr></thead>
    <tbody>
      {failure && <tr className="waf-log-state waf-log-error"><td colSpan={5}><span role="alert">{failure}</span></td></tr>}
      {loading && !logs && !failure ? Array.from({ length: 6 }, (_, index) => <tr className="waf-log-placeholder" key={index} aria-hidden="true">{Array.from({ length: 5 }, (_, column) => <td key={column}><span className="skeleton-block skeleton-line" /></td>)}</tr>) : <>
        {partial && rows.length > 0 && <tr className="waf-log-partial"><td colSpan={5}><span className="waf-rule-status-badge">一部取得</span></td></tr>}
        {rows.map((log, index) => <tr key={index}><td>{log.timestamp ? jst(log.timestamp) : '—'}</td><td>{display(log.clientIp)} / {display(log.country)}</td><td>{display(log.uri)} / {display(log.method)}</td><td><span className={`waf-log-action waf-log-action-${String(log.action).toLowerCase()}`}>{display(log.action)}</span></td><td>{display(log.terminatingRuleId)}</td></tr>)}
        {!rows.length && !failure && <tr className="waf-log-state"><td colSpan={5}>{partial && <span className="waf-rule-status-badge">一部取得</span>}{empty}</td></tr>}
      </>}
    </tbody>
  </table></div>;
}
